import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class TenantInterceptor implements HttpInterceptor {

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Verifica si el request ya tiene el header 'Tenant'
    const hasTenantHeader = req.headers.has('Tenant');

    // Si el request ya tiene 'Tenant', lo dejamos; si no, tomamos el de localStorage
    const tenantValue = hasTenantHeader ? req.headers.get('Tenant')! : (localStorage.getItem('cId') ?? '');

    // Clonamos el request solo si es necesario
    const clonedRequest = hasTenantHeader ? req : req.clone({
      setHeaders: {
        'Tenant': tenantValue
      }
    });

    return next.handle(clonedRequest);
  }
}
